import { render, staticRenderFns } from "./InformacaoAgricula.vue?vue&type=template&id=770eb368&scoped=true&lang=pug"
import script from "./InformacaoAgricula.vue?vue&type=script&lang=js"
export * from "./InformacaoAgricula.vue?vue&type=script&lang=js"
import style0 from "./InformacaoAgricula.vue?vue&type=style&index=0&id=770eb368&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770eb368",
  null
  
)

export default component.exports